export default "__VITE_ASSET__BUoPE8uI__"